import RouteConstants from '@/features/router/RouteConstants';
import { LuCircleCheck, LuPartyPopper } from 'react-icons/lu';
import { Channel } from './ChannelStepContainer';
import { TFunction } from 'i18next';
import { useHistory } from 'react-router-dom';

type TSentSuccess = {
  sent: 'draft' | 'sent' | string;
  resetWizard: () => void;
  history: ReturnType<typeof useHistory>;
  t: TFunction;
  communicationName: string;
  channels: Channel[];
};

export const SentSuccess = ({ sent, resetWizard, history, t, communicationName, channels }: TSentSuccess) => {
  return (
    <section className='mt-6 rounded-2xl border px-10 py-16 text-center'>
      <span className='mx-auto flex size-16 items-center justify-center rounded-full bg-brand-50'>
        {sent === 'draft' ? <LuCircleCheck className='size-8 text-brand-700' /> : <LuPartyPopper className='size-8 text-brand-700' />}
      </span>
      <span className='mt-5 inline-block rounded-full bg-brand-50 px-3 py-1 text-[11.5px] font-semibold uppercase tracking-wide text-brand-700'>
        {t(`success.pill.${sent}`)}
      </span>
      <h2 className='mt-4 text-[26px] font-semibold tracking-tight '>{t(`success.title.${sent}`)}</h2>
      <p className='mx-auto mt-2 max-w-lg text-[15px] text-tertiary-600'>{t(`success.message.${sent}`, { name: communicationName })}</p>
      <div className='mt-5 flex flex-wrap items-center justify-center gap-2'>
        {(['whatsapp', 'sms', 'email'] as Channel[])
          .filter((c) => channels.includes(c))
          .map((channel) => (
            <span key={channel} className='rounded-full border bg-secondary-background px-3.5 py-1.5 text-[13px] font-medium '>
              {t(`channel.${channel}`)}
            </span>
          ))}
      </div>
      <div className='mt-8 flex items-center justify-center gap-3'>
        <button
          type='button'
          onClick={resetWizard}
          className='rounded-[10px] border bg-white-100 px-6 py-3 text-[15px] font-medium  hover:bg-secondary-background'
        >
          {t('success.newCommunication')}
        </button>
        <button
          type='button'
          onClick={() => history.push(RouteConstants.campaigns)}
          className='rounded-[10px] bg-brand-700 px-6 py-3 text-[15px] font-medium text-white-100 hover:bg-brand-800'
        >
          {t('success.goToCampaigns')}
        </button>
      </div>
    </section>
  );
};
